module.exports = __webpack_public_path__ + "static/media/logoWhite.05ea663a.png";